
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Coproratecabandbusserviceisangli() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Service in Sangli',
        heading: 'etravo :  Corporate Cab and Bus Service in Sangli',
        headingDescription: 'eTravo provides top-tier Corporate Cab and Bus Services in Sangli, built specifically for business travel and employee transportation. Whether your organization requires executive cabs for official meetings or large-capacity buses for daily staff commutes and corporate functions, we deliver dependable, punctual, and comfortable solutions. Our fleet is tailored to meet the professional standards of corporate travel, supported by experienced chauffeurs and real-time tracking. Choose eTravo in Sangli for seamless and efficient business mobility services.',

        top: 'Top Places to Visit in Sangli with etravo',

        "topPlaces": [
    {
      "title": "Ganapati Temple",
      "description": "Constructed in 1843 by Thorle Chintamanrao Patwardhan, this temple is dedicated to Lord Ganapati, the guardian deity of Sangli. Known for its black stone architecture and spacious courtyard, the temple is a significant spiritual center and a hub for cultural gatherings, especially during Ganesh Chaturthi."
    },
    {
      "title": "Sagareshwar Wildlife Sanctuary",
      "description": "A unique man-made sanctuary spanning 10.87 km², Sagareshwar is home to various species like deer, wild boars, and peacocks. The sanctuary also houses ancient temples, including a prominent Shiva temple, making it a blend of natural beauty and spiritual significance."
    },
    {
      "title": "Dandoba Hills Forest Reserve",
      "description": "Located near Miraj, Dandoba Hills is a serene forest reserve ideal for trekking and nature walks. The area is rich in biodiversity and offers panoramic views, making it a favorite spot for nature enthusiasts and photographers."
    },
    {
      "title": "Sangli Fort",
      "description": "Situated in the heart of the city, Sangli Fort is a historical structure that once served as the residence of the Patwardhan dynasty. The fort complex includes a museum and government offices, reflecting the architectural style of the Maratha period."
    },
    {
      "title": "Chandoli National Park",
      "description": "Part of the Sahyadri Tiger Reserve, Chandoli National Park covers an area of 317.67 km². The park is home to diverse wildlife, including tigers, leopards, and Indian bison. It's also known for its scenic landscapes, waterfalls, and historical forts like Prachitgad."
    },
    {
      "title": "Bahubali Hill Temple, Kumbhoj",
      "description": "A revered Jain pilgrimage site, the Bahubali Hill Temple features a 28-foot-tall statue of Lord Bahubali. Located atop a hill, the temple offers a tranquil environment and panoramic views of the surrounding countryside."
    },
    {
      "title": "Sangmeshwar Temple, Haripur",
      "description": "An ancient temple dedicated to Lord Shiva, Sangmeshwar Temple is situated at the confluence of the Krishna and Warana rivers. The temple's serene ambiance and historical significance make it a popular spot for devotees and tourists alike."
    },
    {
      "title": "Machindragad Fort",
      "description": "Built by Chhatrapati Shivaji Maharaj in 1676, Machindragad Fort is located atop a solitary hill. Though in ruins, the fort offers insights into Maratha history and provides trekkers with a rewarding climb and scenic views."
    },
    {
      "title": "Dargah of Meerasaheb, Miraj",
      "description": "A symbol of communal harmony, the Dargah of Meerasaheb is dedicated to the Sufi saint Hazarat Meerasaheb. The complex includes a mosque and a temple, attracting devotees from various faiths, especially during the annual URS festival."
    },
    {
      "title": "Krishna River Ghats",
      "description": "The ghats along the Krishna River in Sangli are popular spots for relaxation and spiritual activities. Visitors can enjoy boat rides, witness religious rituals, or simply take in the scenic beauty of the riverbanks."
    }
  ],
  "services": [
    {
      "name": "Corporate Transportation Services in Sangli",
      "description": "eTravo provides professional and dependable corporate transportation services in Sangli, offering tailored mobility solutions for businesses of all sizes. Whether you need regular employee commutes, executive travel, or client transfers, we offer scalable and flexible transport services. Our well-maintained fleet includes air-conditioned cabs and buses with GPS tracking, ensuring a safe, punctual, and hassle-free travel experience for your organization."
    },
    {
      "name": "Hire Staff Cabs & Buses Sangli",
      "description": "Looking to hire staff cabs and buses in Sangli? eTravo delivers flexible rental solutions for businesses requiring daily employee transport or temporary mobility for projects and events. Choose from a variety of vehicles—ranging from economy cabs to full-sized AC buses—available on hourly, daily, or monthly contracts. All rentals come with trained drivers, 24/7 support, and a focus on safety and punctuality."
    },
    {
      "name": "Office Commute Cab Services Sangli",
      "description": "Make daily travel stress-free for your team with eTravo’s office commute cab services in Sangli. Our route-optimized and shift-aligned cab services ensure timely pickup and drop-off of your employees, even during odd hours. Each cab is equipped with air-conditioning and real-time GPS monitoring to guarantee safety, convenience, and complete transparency for your HR and operations teams."
    },
    {
      "name": "Corporate Event Transportation Sangli",
      "description": "Planning a corporate event in Sangli? eTravo specializes in managing logistics for conferences, training sessions, seminars, and team outings with our corporate event transportation services. We provide end-to-end coordination with dedicated event support, offering clean, comfortable, and on-time buses and cabs to move your teams or guests efficiently and professionally."
    },
    {
      "name": "Reliable Bus Rentals for Companies in Sangli",
      "description": "eTravo offers reliable and affordable bus rental services in Sangli specifically designed for companies. Whether it’s regular office commutes, factory shifts, or inter-office travel, our buses are equipped with air-conditioning, ample seating, and safety features. With customized travel plans and backup vehicles on standby, we ensure uninterrupted service to support your daily business operations."
    },
    {
      "name": "Employee Shuttle Solutions in Sangli",
      "description": "eTravo’s employee shuttle solutions in Sangli are perfect for businesses looking to provide transportation for their workforce. We offer route planning, flexible pickup points, and dedicated shuttle vehicles with tracking capabilities. This service improves staff punctuality, reduces absenteeism, and ensures smooth daily travel for teams located across different parts of the city."
    },
    {
      "name": "Luxury Bus and Cab Hire for Business Travel in Sangli",
      "description": "Experience premium corporate mobility with eTravo’s luxury bus and cab hire services in Sangli. Ideal for high-level executives, VIP guests, and long-distance business travel, our luxury vehicles come with plush interiors, AC, entertainment systems, and courteous drivers. Whether it’s a board meeting, site visit, or business tour, travel in comfort and style with our executive transport options."
    }
  ],
  "tableData": [
    ["Corporate Transportation Services in Sangli", "Hire Staff Cabs & Buses Sangli"],
    ["Office Commute Cab Services Sangli", "Corporate Event Transportation Sangli"],
    ["Reliable Bus Rentals for Companies in Sangli", "Employee Shuttle Solutions in Sangli"],
    ["Luxury Bus and Cab Hire for Business Travel in Sangli", ""]
  ],







 "whychoose": [
    {
        "WhyChooseheading": "Punctual and Dependable Corporate Transport",
        "WhyChoosedescription": "At eTravo, we understand the importance of time management in the corporate world. Our cab and bus services in Sangli are designed to ensure prompt pickups and drop-offs, helping your employees and clients reach their destinations without any delays, so your business operations run smoothly and efficiently."
    },
    {
        "WhyChooseheading": "Wide Range of Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Whether you need executive cabs for client meetings or spacious buses for group travel, eTravo offers a diverse fleet equipped with modern amenities like air conditioning, comfortable seating, and ample luggage space. Every vehicle undergoes regular maintenance to guarantee a safe and comfortable journey across Sangli."
    },
    {
        "WhyChooseheading": "Professional, Experienced, and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are carefully selected for their professionalism, driving skills, and knowledge of Sangli’s routes. They prioritize your safety and comfort, ensuring smooth rides while maintaining corporate etiquette to provide a respectful and reliable travel experience."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing with No Hidden Fees",
        "WhyChoosedescription": "We believe in clear communication and transparency. eTravo provides detailed pricing breakdowns upfront for all corporate cab and bus services in Sangli, so you can budget effectively without worrying about unexpected costs. Our competitive rates deliver excellent value for premium transport services."
    },
    {
        "WhyChooseheading": "Top-Notch Safety Standards for Peace of Mind",
        "WhyChoosedescription": "Safety is at the core of everything we do. Our vehicles are equipped with GPS tracking, seat belts, first aid kits, and fire extinguishers, while undergoing routine inspections to ensure your team’s security throughout every trip in Sangli."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Flexible Scheduling",
        "WhyChoosedescription": "eTravo’s customer support team is available round the clock to assist with bookings, route changes, and any special requirements. We adapt to your corporate schedule, whether it involves early morning departures, late-night returns, or last-minute travel adjustments."
    },
    {
        "WhyChooseheading": "Effortless Online Booking and Management",
        "WhyChoosedescription": "Our user-friendly online booking system allows you to schedule and manage your corporate transportation in Sangli with ease. Real-time updates and prompt customer assistance ensure a hassle-free experience from start to finish."
    },
    {
        "WhyChooseheading": "Customized Corporate Travel Solutions Tailored to Your Needs",
        "WhyChoosedescription": "Recognizing that every business has unique requirements, eTravo offers flexible and customized corporate cab and bus packages in Sangli. Whether it’s regular employee commutes, corporate events, or intercity business trips, we tailor our services to fit your exact needs, helping you create a seamless travel experience for your workforce."
    }
]





















    }


   



// Corporate Cab and Bus Service in Sangli – eTravo

const faqData = [
    [
        {
            question: 'What corporate transportation services does eTravo offer in Sangli?',
            answer: 'eTravo provides specialized corporate cab and bus services in Sangli, including employee transport, business meeting transfers, offsite travel, and VIP cab bookings for executives.',
        },
        {
            question: 'Can eTravo manage daily staff transportation for our office in Sangli?',
            answer: 'Yes, we offer dependable daily commute solutions with route planning, time management, and shift-based transport using both cabs and AC buses tailored to your company’s requirements.',
        },
        {
            question: 'What vehicle options are available for corporate clients in Sangli?',
            answer: 'Our fleet includes premium cabs for executives, multi-seater vehicles for team travel, and well-maintained AC buses for larger staff movement — all focused on comfort and safety.',
        },
        {
            question: 'Does eTravo provide tech-enabled tracking and reporting features?',
            answer: 'Yes, all vehicles are GPS-enabled. Corporate clients get access to live tracking dashboards, trip logs, and usage reports for complete visibility and control over transportation operations.',
        },
        {
            question: 'Can we use eTravo for one-time corporate events or site visits in Sangli?',
            answer: 'Absolutely. We offer flexible one-time booking options for corporate events, site inspections, and intercity business visits with fully professional coordination and execution.',
        },
        {
            question: 'Is there dedicated account management support for Sangli clients?',
            answer: 'Yes, a dedicated account manager will handle your organization’s transportation needs, including onboarding, scheduling, reporting, and day-to-day coordination.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Shinde',
        designation: 'Admin Officer, CoreVision Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate cab and bus service in Sangli has significantly improved our employee punctuality and satisfaction. The service is always on time and professionally managed.”',
    },
    {
        name: 'Ms. Pooja Jagtap',
        designation: 'HR Executive, AlphaEdge Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for all our corporate transport in Sangli — from daily cabs to large buses for team events. Their service is consistent, clean, and always meets our expectations.”',
    },
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Service in Sangli",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-sangli.jpg",
  "description": "Book corporate cab and bus services in Sangli with eTravo for reliable staff transportation, office commute, and corporate event travel. Choose from luxury and affordable buses and cabs with professional drivers and flexible booking options.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-service-in-sangli"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Service in Sangli | Staff Transport & Event Travel | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Sangli with eTravo. Reliable employee shuttle, office commute, and event transportation with luxury and affordable vehicle options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/5.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Coproratecabandbusserviceisangli;